<template>
  <div class="container">
    <h3>Productos</h3>
    <Table :showFilter="true" />
  </div>
</template>

<script>
import Table from "@/views/products/table.vue";
export default {
  name: "products",
  components: {
    Table,
  },
};
</script>
